import styled from 'styled-components';

const SubscribeFormContainer = styled.div`
  position: relative;

  .subscribe-modal-button--button {
    height: 40px;
    width: 137px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 30px !important;
    margin-left: 15px;
    padding: 0;

    @media (max-width: 576px) {
      width: 121px;
    }
  }

  .subscribe-modal-button--subscribe-container {
    width: 435px;
    padding: 12px;
    position: absolute;
    margin-top: 20px;
    margin-left: -280px;
    background: white;
    box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
    border-radius: 2px;

    @media (max-width: 576px) {
      width: 90vw;
      margin-left: -45vw;
    }

    &:before {
      content: '';
      position: absolute;
      margin: auto;
      width: 20px;
      height: 20px;
      transform: rotate(225deg);
      -webkit-transform: rotate(225deg);
      -moz-transform: rotate(225deg);
      -o-transform: rotate(225deg);
      border: none;
      -ms-transform: rotate(225deg);
      border-right: 1px solid #e9eff2;
      border-bottom: 1px solid #e9eff2;
      background: transparent;
      z-index: 1000;
      right: 54px;
      margin-top: -22px;
      transition: all 0.25s ease-out;

      @media (max-width: 576px) {
        right: 90px;
      }
    }

    &:after {
      content: '';
      position: absolute;
      margin: auto;
      border: none;
      z-index: 999;
      right: 50px;
      top: -13px;
      transition: all 0.25s ease-out;
      width: 0;
      height: 0;
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      border-bottom: 14px solid white;

      @media (max-width: 576px) {
        right: 86px;
      }
    }

    & > div {
      &:first-child {
        display: none;
      }

      &:last-child {
        box-shadow: none !important;
      }

      .signup-form--form {
        .data-layer-form {
          margin-top: 0;
        }

        .ant-form-item {
          &:first-child {
            width: 100%;
            margin-right: 16px;
          }

          .text-field-wrapper {
            .text-field-input {
              width: 100%;
              height: 62px !important;
              margin-right: 0;
              padding: 16px 20px;
              font-size: 20px !important;
            }

            .text-field-helper {
              display: none;
            }
          }

          button {
            font-size: 20px;
            line-height: 110%;
            height: 62px;
            box-shadow: none;
            padding: 24px 20px;
          }
        }
      }
    }
  }
`;

export { SubscribeFormContainer };
